export default __webpack_public_path__ + "static/media/euro-circle.8049a2b6.svg";